import { FC } from "react"
import { useFetchSubscriptionConfigsQuery } from "../../../../redux/queries"
import { Brand } from "../../../../types"
import { useBrandSearchParam } from "../../../hooks"
import ConfigListShell from "../config-list-shell"
import SubscriptionConfigTable from "./table"

interface Props {
  brands: Brand[]
}

const ConfigSubscription: FC<Props> = ({ brands }) => {
  const [selectedBrandId, setSelectedBrandId] = useBrandSearchParam()

  const { data, isFetching } = useFetchSubscriptionConfigsQuery({
    brand_id: selectedBrandId
  })

  return (
    <ConfigListShell
      brands={brands}
      selectedBrandId={selectedBrandId}
      onBrandChange={setSelectedBrandId}
    >
      <SubscriptionConfigTable
        data={data ?? []}
        brands={brands}
        isFetching={isFetching}
      />
    </ConfigListShell>
  )
}

export default ConfigSubscription
